/**
 * Log persistente de sync (Django estudyoo-sync).
 */
import * as DjangoSync from '@/services/DjangoSyncService';

export function mapLogServidorAUi(row, idx = 0) {
  const det = row.detalle || {};
  return {
    rowKey: row.id || `srv-${idx}-${row.entidad}-${row.id_externo}`,
    fase: row.fase || det.fase || '—',
    entidad: row.entidad || '—',
    accion: row.accion || (row.ok ? 'ok' : 'error'),
    ok: row.ok !== false,
    id: row.id_externo || '—',
    etiqueta: det.etiqueta || '',
    mensaje: row.mensaje || '',
    cambios: det.cambios || (det.stale ? det.stale.map((ie) => ({
      campo: 'stale',
      anterior: ie,
      nuevo: null,
    })) : []),
    djangoId: row.django_id || null,
    creadoEn: row.creado_en || null,
    fuente: det.fuente || 'servidor',
  };
}

/** Carga todas las páginas del log en Django (sin límite de 800 del navegador). */
export async function cargarLogSesionCompleto(sesionId, opts = {}) {
  const {
    soloError = false,
    entidad = null,
    accion = null,
    orden = 'desc',
    pageSize = 1000,
    onProgress = null,
  } = opts;
  const params = { limit: pageSize, orden };
  if (soloError) params.solo_error = '1';
  if (entidad) params.entidad = entidad;
  if (accion) params.accion = accion;

  const all = [];
  let offset = 0;
  let total = 0;
  do {
    const { data } = await DjangoSync.logsSesion(sesionId, { ...params, offset });
    total = data.total ?? 0;
    const chunk = (data.logs || []).map((r, i) => mapLogServidorAUi(r, offset + i));
    all.push(...chunk);
    if (onProgress) onProgress({ cargados: all.length, total });
    offset += chunk.length;
    if (!data.has_more || !chunk.length) break;
  } while (offset < total);
  return { logs: all, total };
}

export async function cargarErroresSesion(sesionId) {
  return cargarLogSesionCompleto(sesionId, { soloError: true, orden: 'asc' });
}

export function descargarJson(nombre, datos) {
  const blob = new Blob([JSON.stringify(datos, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nombre;
  a.click();
  URL.revokeObjectURL(url);
}

export function descargarErroresSesion(sesionId, errores, meta = {}) {
  descargarJson(
    `sync-errores-${sesionId.slice(0, 8)}.json`,
    {
      sesion_id: sesionId,
      exportado_en: new Date().toISOString(),
      ...meta,
      errores,
    },
  );
}

const LS_SESION = 'estudyoo_ultima_sync_sesion_id';

export function guardarSesionLocal(sesionId) {
  if (sesionId) localStorage.setItem(LS_SESION, sesionId);
}

export function leerSesionLocal() {
  return localStorage.getItem(LS_SESION) || '';
}
